import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lesson" }
const _hoisted_2 = ["textContent"]

import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Actions } from "@/store";
import { Lesson } from "@/models/lesson";


export default /*#__PURE__*/_defineComponent({
  __name: 'Lesson',
  setup(__props) {

const store = useStore();
const route = useRoute();
const lesson = computed<Lesson>(() => store.state.lesson);

onMounted(() => {
  store.dispatch(Actions.GetLesson, route.params.id);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", {
      textContent: _toDisplayString(lesson.value.name)
    }, null, 8, _hoisted_2)
  ]))
}
}

})